export const apiName: string = 'situacoes';



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/bens/situacoes/data.service.ts
 **/